import { render, staticRenderFns } from "./CrudEducationDetails.vue?vue&type=template&id=512ab894&scoped=true"
import script from "./CrudEducationDetails.vue?vue&type=script&lang=ts"
export * from "./CrudEducationDetails.vue?vue&type=script&lang=ts"
import style0 from "./CrudEducationDetails.vue?vue&type=style&index=0&id=512ab894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ab894",
  null
  
)

export default component.exports